export enum AIQuizLimitExceededType {
	AI = 'ai',
	TOTAL = 'total',
	BACKEND_MESSAGE = 'backend_message'
}